import {
  getPreviousResaleEnquiryMfaCustomerUrl,
  getPreviousResaleEnquiryNonMfaCustomerUrl,
  getResaleTractorDataForMFACustomerUrl,
  getResaleTractorDataForNonMFACustomerUrl,
  getResaleTractorDetailsForMfaCustomerUrl,
  getResaleTractorDetailsForNonMfaCustomerUrl,
  postNonMFAResaleAssetEnquiryUrl,
  postResaleAssetEnquiryUrl,
} from './resale.helper';

import {loadModuleTxFile} from '../../i18n';
import {getAPICall, postAPICall} from '../../services/apiCallsHandler';

import {call} from 'redux-saga/effects';

export function* loadResaleTractorDataForMfaService(
  customerId,
  stateCode = ''
) {
  const resaleTractorData = yield call(
    getAPICall,
    getResaleTractorDataForMFACustomerUrl(customerId, stateCode),
    {
      isCallBack: true,
      errorTag: 'GET_RESALE_DATA',
      logInfoMsg: 'load data for resale assets mfa customer',
      redirectToOops: false,
    },
    {}
  );
  return resaleTractorData;
}

export function* loadResaleTractorDataForNonMfaService(stateCode = '') {
  const resaleTractorData = yield call(
    getAPICall,
    getResaleTractorDataForNonMFACustomerUrl(stateCode),
    {
      isCallBack: true,
      errorTag: 'GET_RESALE_DATA',
      logInfoMsg: 'load data for resale assets for non mfa customer',
      redirectToOops: false,
    },
    {}
  );
  return resaleTractorData;
}

export function* loadAssetDetailsForResaleTractorServiceNonMfa(assetId) {
  const resaleTractorDetailsData = yield call(
    getAPICall,
    getResaleTractorDetailsForNonMfaCustomerUrl(assetId),
    {
      isCallBack: true,
      errorTag: 'GET_RESALE_ASSET_DETAILS_DATA_NON_MFA',
      logInfoMsg: 'load details for resale assets',
      redirectToOops: false,
    },
    {}
  );
  return resaleTractorDetailsData;
}

export function* loadAssetDetailsForResaleTractorServiceMfa(
  customerId,
  assetId
) {
  const resaleTractorDetailsData = yield call(
    getAPICall,
    getResaleTractorDetailsForMfaCustomerUrl(customerId, assetId),
    {
      isCallBack: true,
      errorTag: 'GET_RESALE_ASSET_DETAILS_DATA_MFA',
      logInfoMsg: 'load details for resale assets',
      redirectToOops: false,
    },
    {}
  );
  return resaleTractorDetailsData;
}

export function* submitResaleAssetEnquiryMfa(customerId, assetId) {
  const payload = {
    customerId,
    assetId,
  };
  const resaleTractorData = yield call(
    postAPICall,
    postResaleAssetEnquiryUrl(customerId),
    payload,
    {
      isCallBack: true,
      errorTag: 'POST_RESALE_DATA',
      logInfoMsg: 'submit mfa enquiry ',
      redirectToOops: false,
    },
    {}
  );
  return resaleTractorData;
}

export function* submitResaleAssetEnquiryNonMfa(payload) {
  const resaleTractorData = yield call(
    postAPICall,
    postNonMFAResaleAssetEnquiryUrl(),
    payload,
    {
      isCallBack: true,
      errorTag: 'POST_RESALE_DATA',
      logInfoMsg: 'submit non mfa enquiry',
      redirectToOops: false,
    },
    {}
  );
  return resaleTractorData;
}

export function* getPreviousResaleEnquiryServiceMfa(customerId) {
  const resalePreviousEnquiryData = yield call(
    getAPICall,
    getPreviousResaleEnquiryMfaCustomerUrl(customerId),
    {
      isCallBack: true,
      errorTag: 'GET_PREVIOUS_RESALE_ENQUIRY_MFA',
      logInfoMsg: 'get previous resale enquiry mfa',
      redirectToOops: false,
    },
    {}
  );
  return resalePreviousEnquiryData;
}

export function* getPreviousResaleEnquiryServiceNonMfa() {
  const resalePreviousEnquiryData = yield call(
    getAPICall,
    getPreviousResaleEnquiryNonMfaCustomerUrl(),
    {
      isCallBack: true,
      errorTag: 'GET_PREVIOUS_RESALE_ENQUIRY_NON_MFA',
      logInfoMsg: 'get previous resale enquiry non mfa',
      redirectToOops: false,
    },
    {}
  );
  return resalePreviousEnquiryData;
}

export function* loadTranslations() {
  yield call(loadModuleTxFile, 'resale');
  yield call(loadModuleTxFile, 'offers');
}
